// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1HZwK","row":"styles_row__2QQRy"};